<mat-toolbar>
  <h4>Upload Report and Fees Invoice</h4>
</mat-toolbar>
<div class="row text-center content">
    <div class="add-upload-button">
      <button mat-raised-button class=""  [class.loading]="uploadLoading" [disabled]="uploadLoading" aria-label="Upload" (click)="FileInput.click()" value="Report" tooltip="Upload Report">
        <mat-icon class="add">file_upload</mat-icon>Upload Report
      </button>
      <button mat-raised-button class=""  [class.loading]="uploadLoading" [disabled]="uploadLoading" aria-label="Upload" (click)="FileInput2.click()" value="Report" tooltip="Upload Fees Invoice">
        <mat-icon class="add">file_upload</mat-icon>Upload Fees Invoice
      </button>
    </div>

    <input hidden type="file" #FileInput (change)="fileUpload($event)" />
    <input hidden type="file" #FileInput2 (change)="fileUpload2($event)" />

</div>


// WEBPACK FOOTER //
// ./src/app/main/shared/dialog/guardian-upload-doc-dialog/guardian-upload-doc-dialog.component.html